import { SettingConst } from '../../types';

/**
 * If enabled, we show an updated version of the PDP page for logged out users from the Faire Direct flow
 * https:www.notion.so/faire/Improve-Logged-Out-FD-PDP-Sign-Up-Visibility-eb72e44091704745aab772ee88cee712
 */
export const FAIRE_DIRECT_PDP_SIGN_UP_240808 =
  'FAIRE_DIRECT_PDP_SIGN_UP_240808' as SettingConst<
    'FAIRE_DIRECT_PDP_SIGN_UP_240808',
    boolean,
    'RETAILER'
  >;
